import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  initOriginalReport,
  setOriginalReport,
  setErrors
} from "redux/modules/originalReport";

// Component
import OriginalReport from "components/ReportDetail/OriginalReport";
// Utils
import history from "utils/history";

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  initOriginalReport: () => {
    dispatch(initOriginalReport());
  },
  fetchOriginalReport: () => {
    const { id } = ownProps.match.params;

    const params = new URLSearchParams(window.location.search);
    const attrItem = params.get('attr_item');
    if (attrItem) {
      api
        .get(`original_report/${id}`, { attr_item_id: attrItem })
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setOriginalReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    } else {
      api
        .get(`original_report/${id}`)
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setOriginalReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(OriginalReport);



// WEBPACK FOOTER //
// ./src/containers/ReportDetail/OriginalReportContainer.js